export default "__VITE_ASSET__YdYI$kt5__"